import React from "react";
import { useEffect } from "react";
import { DeviceType } from "../../../helpers/constants/constant";
import { getDeviceType } from "../../../utils/CommonFunction";
import { EKYC_LOGIN_SUBTITLE } from "./constant";
import {
  FormStyle,
} from "../../login/components/RightSideContainer";
import { MobileTextBox } from "../../../components/MobileTextBox";
import { Button } from "../../../components/Button";
import FooterMobile from "../../login/components/FooterMobile";
import { useHistory } from "react-router-dom";
import OtpSentAction from "../../../actions/ekyc/login/otpSent";
import { EKYC } from "../../../helpers/constants/routes";
import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import { VerifyNumberAPI } from "../../../helpers/constants/ekycApiUrl";
import CommonInput from "../../login/componentLoginScreen/CommonInput";
const CouponUserDetails = () => {
  const history = useHistory();

  const [data, setData] = React.useState({
    name: "",
    username: "",
    userPhoneNumber: "",
    isError: false,
    errorObj: {},
    isLoading: false,
    isSessionClear: false,
    mobileView: false,
    errorMsg: "",
  });

  useEffect(() => {
    const mobileView =
      getDeviceType() === DeviceType.MOBILE ||
      getDeviceType() === DeviceType.TABLET;

    const stateData = history?.location?.state || {};

    setData((prev) => ({
      ...prev,
      mobileView: mobileView,
      name: stateData?.name || "",
      username: stateData?.username || "",
      userPhoneNumber: stateData?.phone || "",
    }));

    const sessionData = JSON.parse(localStorage.getItem("451")) || {};
    if (Object.keys(sessionData).length) {
      setData((prev) => ({
        ...prev,
        isSessionClear: true,
        isError: true,
        errorObj: {
          ...sessionData,
        },
      }));

      localStorage.removeItem("451");
    }
  }, []);

  const onChangeAction = (e) => {
    const { name, value } = e.target;
    let cleanValue = value;
    if (name === "userPhoneNumber") {
      cleanValue = value.replace(/\D/g, "");
      if (cleanValue.length === 11) {
        return false;
      }
    }

    setData((prev) => ({
      ...prev,
      [name]: cleanValue,
      errorMsg: "", 
    }));
  };

  const navigateToCouponLogin = (e) => {
    e && e.preventDefault();
    // history.push(EKYC.LOGIN);
  };

  const triggerOTP = () => {
    const errors = {};

    if (!data.name || !data.name.trim()) {
      errors.name = "User name is required";
    }

    if (!data.userPhoneNumber || !data.userPhoneNumber.toString().trim()) {
      errors.userPhoneNumber = "Mobile number is required";
    }

    if (data.userPhoneNumber && data.userPhoneNumber.toString().length !== 10) {
      errors.userPhoneNumber = "Mobile number must be 10 digits";
    }

    if (Object.keys(errors).length > 0) {
      setData((prev) => ({
        ...prev,
        isError: true,
        errorObj: errors,
      }));
      return;
    }

    setData({ ...data, isLoading: true, errorMsg: "" });
    triggerSimpleAjax(
      VerifyNumberAPI(data.username),
      "PATCH",
      {
        name: data.name,
        phone_number: `+91${data.userPhoneNumber}`,
        related_coupon_code__status: "claimed",
      },

      (response) => {
        console.log("User Update Success", response);

        OtpSentAction({
          login_username: `+91${data.userPhoneNumber}`,
          method_of_login: "phone_otp",
          purpose: "user_login",
        })
          .then((res) => {
            console.log("OTP Sent", res);

            setData({
              ...data,
              isLoading: false,
              resendCountdown: 30,
            });

            history.push(EKYC.VERIFYOTPANDLOGIN, {
              mobileView: data.mobileView,
              name: data.name,
              phone: data.userPhoneNumber,
            });
          })
          .catch((error) => {
            console.log("OTP Failed", error);

            setData({
              ...data,
              isLoading: false,
              errorMsg: "Failed to send OTP",
            });
          });
      },

      (error) => {
        console.log("PATCH Failed", error);

        const msg =
          error?.phone_number?.[0] ||
          error?.detail ||
          error?.message ||
          "User already exists";

        setData((prev) => ({
          ...prev,
          isLoading: false,
          errorMsg: msg,
        }));
      },
    );
  };
  return data.mobileView ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        maxWidth: "440px",
        padding: "2.5rem 1.5rem",
        marginTop: "-30px",
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
        zIndex: 2,
      }}
    >
      <h3 style={{ fontSize: 18, fontWeight: "600", color: "#333", marginBottom: "8px" }}>Coupon Registration 👋</h3>
      <p style={{ padding: 0, margin: "0 0 15px 0", fontSize: 14, color: "#666", textAlign: "center" }}>
        {EKYC_LOGIN_SUBTITLE}
      </p>
      <FormStyle style={{ width: "100%" }}>
        <MobileTextBox
          labelName="User name"
          placeholder="Enter User name"
          name={"name"}
          value={data.name}
          type="text"
          onChange={onChangeAction}
          error={data.isError}
          errorMessage={data.errorObj?.name}
        />
        <MobileTextBox
          labelName="Mobile Number"
          placeholder="Enter Mobile Number"
          name={"userPhoneNumber"}
          value={data.userPhoneNumber}
          type="tel"
          onChange={onChangeAction}
          error={data.isError}
          errorMessage={data.errorObj?.userPhoneNumber}
        />
        {data.errorMsg && (
          <p style={{ color: "red", marginTop: 6, fontSize: 13 }}>
            {data.errorMsg}
          </p>
        )}
        <Button
          type="submit"
          onClick={triggerOTP}
          isLoading={data.isLoading}
          width="100%"
          bgColor="#4770C1"
          borderRadius="8px"
          fontStyle={{ fontSize: "14px", marginTop: "35px" }}
          boxHeight="38px"
        >
          {data.isSessionClear ? "Logout All Session" : "Send OTP"}
        </Button>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            marginTop: "35px",
          }}
        >
          <p style={{ margin: 0, fontSize: "15px", color: "#666" }}>Return To</p>

          <span
            onClick={navigateToCouponLogin}
            style={{
              fontSize: "15px",
              color: "#4770C1",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Login
          </span>
        </div>
      </FormStyle>
      <div style={{ alignItems: "center", marginTop: "20px", borderTop: "1px solid #f1f5f9", paddingTop: "15px", width: "100%" }}>
        <FooterMobile textStyle="small" showSecuritySection={true} />
      </div>
    </div>
  ) : (
    <form className="login-Form" onSubmit={(e) => { e.preventDefault(); triggerOTP(); }}>
      <h2 className="login-heading" style={{ marginBottom: 20 }}>
        Coupon Registration 👋
      </h2>
      <p style={{ color: "#777", marginBottom: 30, fontSize: "16px", fontFamily: "barlow" }}>
        {EKYC_LOGIN_SUBTITLE}
      </p>

      <CommonInput
        type="text"
        label="User name"
        name="name"
        value={data.name}
        onChange={onChangeAction}
        error={data.isError ? data.errorObj?.name : ""}
        autoFocus
      />

      <CommonInput
        type="text"
        inputMode="numeric"
        label="Mobile Number"
        name="userPhoneNumber"
        value={data.userPhoneNumber}
        onChange={onChangeAction}
        error={data.isError ? data.errorObj?.userPhoneNumber : ""}
      />

      {data.errorMsg && (
        <div
          style={{
            color: "#D93025",
            fontSize: "14px",
            fontFamily: "barlow",
            marginTop: "10px",
            textAlign: "center",
          }}
        >
          {data.errorMsg}
        </div>
      )}

      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "45px",
          alignItems: "center",
        }}
      >
        <button
          className="next-button"
          type="submit"
          disabled={data.isLoading}
        >
          {data.isSessionClear ? "Logout All Session" : "Send OTP"}
        </button>

        <span
          onClick={() => history.push(EKYC.LOGIN)}
          style={{
            fontSize: "16px",
            color: "#4770C1",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "500",
            fontFamily: "barlow",
          }}
        >
          Return to Login
        </span>
      </div>
    </form>
  );
};

export default CouponUserDetails;
